/* eslint-disable camelcase */
export default {
	emptyData: '暂无数据',
	supplier_name: '供应商名称',
	account_type: '账号类型',
	add: '添加',
	delete: '删除',
	query: '查询',
	export: '导出',
	import: '导入',
	queryCondition: '查询条件',
	collection: '收藏',
	choose: '请选择',
	warningTitle: '提示',
	contact_person: '联系人',
	ok: '确定',
	cancel: '取消',
	operate: '操作',
	yes: '是',
	no: '否',
	to: '至',
	total: '共',
	days: '天',
	day: '天',
	close: '关闭',
	dateFormat: 'yyyy/MM/dd',
	totalAmount: '金额合计',
	only_look_at_the_collection: '只看收藏',
	selected_supplier: '已选供应商',
	identify_the_supplier_account_number_that_is_collected_by_the_user: '标识被用户收藏的供应商帐号',
	green: '绿色',
	note: '注：',
	confirm: {
		delete: '确定要删除吗？',
		export: '导出可能需要较长时间，请等待。（不要关闭页面或重复点击导出按钮）',
		opinion: '驳回必须填写意见/缺陷。',
		sendMail: '您确定要发送催办邮件吗?'
	},
	message: {
		dataEmpty: '表格数据为空，无法导出。',
		deleteSuccess: '删除成功！',
		deleteCancel: '删除已取消',
		exportCancel: '导出已取消',
		up: '已到达查询结果当前页的第一项',
		down: '已到达查询结果当前页的最后一项',
		date: '结束日期不能小于开始日期',
		approvalAgree: '请选择审批同意的单据',
		approvalDisagree: '请选择审批不同意的单据',
		approvalFundsDisagree: '请选择驳回的单据',
		transferSuccess: '转交成功',
		sendSuccess: '发送成功，申请单ID [{0}]',
		recognizeSuccess: '识别成功',
		recognizeFailed: '识别失败',
		exportError: '导出的数据不允许超出2000行，请提高您的搜索精度或联系管理员8001帮助。',
		agreeSuccess: '审批成功',
		saveSuccess: '保存成功',
		submitSuccess: '提交成功',
		dialogError: '弹窗被阻止，请检查你的浏览器设置后重新再试。',
		doneAudit: '该单已被当前用户审批，不能重复操作。',
		tips: '温馨提示'
	},
	warning: {
		tencentCriterion:
			'我已了解并承诺遵守《腾讯阳光行为准则》和报销相关规定的要求，我承诺我提交的报销信息与相关报销单据都是真实且符合公司报销相关规定的。',
		footerDevInfo: '腾讯公司 财经线-S系统财务管理-业务开发中心, 技术支持: IT热线-财经系统支持(8001)'
	},
	tips: {
		contract: '多个合同号用;分隔',
		market: '多个活动单号用;分隔',
		applyPriority: '该申请单的优先级为[高]'
	},
	status: {
		draft: '草稿',
		processing: '系统处理中',
		relateApprovalAudit: '相关审批人审批',
		businessFinancialAudit: '业务线财管审批',
		businessDeptHeadAudit: '业务部门负责人审批',
		coopDeptHeadAudit: '产业生态合作部负责人审批',
		audited: '审批完成',
		cancelled: '已取消',
		effective: '已完成',
		terminated: '已终止',
		stopped: '已中止',
		deleted: '已删除',
		pendingAcceptance: '待验收',
		acceptance: '已验收',
		vendorConfirm: '供应商确认',
		purchaserConfirm: '采购确认',
		leaderAudit: '直属Leader审批',
		centerChargerAudit: '中心负责人审批',
		priceLibrary: '已进价格库',
		finished: '已完成'
	},
	header: {
		finance_line: '财经线',
		business_procurement_platform: '业务采购平台',
		stars: '星辰',
		welcome: '欢迎您，',
		feedback: '意见反馈',
		OA_home: 'OA首页',
		drop_out: '退出'
	},
	// 价格库查询
	priceLibraryQuery: '价格库查询',
	quotationNo: '报价单号',
	pleaseEnter: '请输入',
	effectiveDate: '生效日期',
	deadTime: '失效日期',
	creator: '创建人',
	creationTime: '创建时间',
	effective: '有效',
	pleaseChoose: '请选择',
	startDate: '开始日期',
	deadline: '结束日期',
	materialCategory: '物料类别',
	materialCode: '物料编码',
	nameOfMaterial: '物料名称',
	brand: '品牌',
	countriesRegions: '国家地区',
	supplier: '供应商',
	abstractType: '抽象类型',
	internalModel: '内部型号',
	advancedSearch: '高级搜索',
	all: '全部',
	clear: '清空',
	priceLibraryQueryResults: '价格库查询结果',
	failurePrice: '失效价格',
	restorePrice: '恢复价格',
	demandLevel: '需求等级',
	unit: '单位',
	number: '数量',
	VATcode: '增值税码',
	TaxCode: '税率',
	currency: '币种',
	priceModel: '价格模式',
	rangePriceDetails: '区间价格详情',
	countriesAndRegions: '国家地区',
	priceWay: '价格方式',
	intervalStrategy: '区间策略',
	policyDimensions: '策略维度',
	taxUnitPrice: '含税单价',
	unitPriceExcludeTax: '不含税单价',
	maximumPurchaseQuantity: '最高采购量',
	effectiveness: '有效性',
	associatedDecisionSheet: '关联决策单',
	byScene: '所属场景',
	rangePriceInfo: '区间价格信息',
	serialNumber: '序号',
	rangeFrom: '区间从',
	rangeTo: '区间至',
	rangeIncludesTaxUnitPrice: '区间含税单价',
	discountValue: '折扣值',
	empty_data: '暂无数据',
	back: '返回',

	// 询价单查询
	inquiry: '询价单查询',
	inquiry_number_number: '询价单编号',
	inquiry_title: '询价标题',
	founder: '创建人',
	create_date: '创建日期',
	inquiry_status: '询价单审批状态',
	country_region: '国家地区',
	manager: '经办人',
	quotation_deadline: '报价截止日期',
	material_coding: '物料编码',
	material_name: '物料名称',
	tendering_method: '招标方式',
	inquiry_type: '询价类型',
	internal_model: '内部型号',
	inquiry_single_synergistic_state: '询价单协同状态',
	inquiry_res: '询价单结果',
	query_results_display_rules: '查询结果显示规则：',
	the_results_of_the_query_are_numbered_by_the_inquiry_order_and_the_inquiry_order_creates_time_order_display:
		'查询的结果按照询价单编号、询价单创建时间顺序显示',
	press_the_query_price_by_large_to_small_display_the_same_inquiry_number_is_displayed_in_the_order_of_creation_time:
		'①按询价单的由大到小显示，相同询价单号按创建时间的先后顺序显示',
	inquiry_description: '询价说明',
	create_time: '创建时间',
	select_strategy: '选择策略',
	participate_in_suppliers: '参与供应商',
	price_validity_period: '价格有效期从',
	price_is_valid_until: '价格有效期至',
	approval_status: '审批状态',
	quotation_status: '报价状态',
	supplier_selection: '供应商选择',
	business_scene: '业务场景',
	associated_inquiry: '关联询价单',
	project_place: '项目地点',
	expected_delivery_date: '期望交付日期',
	demand_category: '需求类别',
	description_of_requirement: '需求描述',
	has_additional_cost: '是否有附加费用',
	last_purchase_price: '上次采购价',
	tax_included_quotation: '含税报价',
	additional_cost: '附加费用',
	yellow: '黄色',
	shading_space_is_separator: '底纹空白行为不同物品的间隔',
	description_of_last_purchase_price: '上次采购价说明：',
	take_the_last_purchase_price: '--取上次采购价格；',
	never_purchased_take_the_commodity_reference_unit_price: '--从未采购，取商品参考单价',
	price_description: '价格说明：',
	higher_than_the_last_purchase_price_or_reference_price: '--高于上次采购价(或参考价)',
	download_template: '下载模版',
	batch_delete: '批量删除',
	import_data: '导入数据',
	import_material: '导入物料',
	associatedDecisionNo: '关联决策',
	inputTime: '录入时间',
	quote_deadline: '报价截止时间',
	MaterialDesc: '物料描述'
};
